export const checkSourceAccessibility = (url: string) =>
  fetch(url, {
    method: "HEAD",
  });
